import { useRef, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Button from "@material-ui/core/Button";
import MediaSession from "@mebtte/react-media-session";
import { Link } from "react-router-dom";

import SearchPage from "./Pages/SearchPage";
import PlaylistPage from "./Pages/PlaylistPage";

const API_URL = "https://api-locktube.kazoo.agency";

const App = () => {
  const audioRef = useRef(null);
  const [unlocked, setUnlocked] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [title, setTitle] = useState("");
  const [total, setTotal] = useState(null);
  const [progress, setProgress] = useState(null);
  const [position, setPosition] = useState(null);
  const [currentId, setCurrentId] = useState(null);
  const [mode, setMode] = useState("song");
  const theme = createMuiTheme({
    palette: {
      type: "dark",
    },
  });

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {unlocked ? null : (
          <div id="lock">
            <Button
              onClick={() => {
                audioRef.current.play();
                audioRef.current.pause();
                setUnlocked(true);
              }}
              className="unlockButton"
            >
              Touch to start
            </Button>
          </div>
        )}
        <Button>Mode: </Button>
        <Link
          to="/"
          onClick={() => {
            setMode("song");
          }}
        >
          <Button color="primary" variant={mode === "song" ? "contained" : ""}>
            Song
          </Button>
        </Link>
        <Link
          to="/playlist"
          onClick={() => {
            setMode("playlist");
          }}
        >
          <Button color="primary" variant={mode === "song" ? "" : "contained"}>
            Playlist
          </Button>
        </Link>
        <h1>LockTube</h1>
        <p>
          Listen to Youtube with your phone screen locked or while browsing
          reddit
        </p>
        <div className="App">
          <div>
            <Switch>
              <Route path="/playlist">
                <PlaylistPage
                  audioRef={audioRef}
                  API_URL={API_URL}
                  setDownloading={setDownloading}
                  setTitle={setTitle}
                  setTotal={setTotal}
                  setProgress={setProgress}
                  setPosition={setPosition}
                  setCurrentId={setCurrentId}
                />
              </Route>
              <Route path="/">
                <SearchPage
                  audioRef={audioRef}
                  API_URL={API_URL}
                  setDownloading={setDownloading}
                  setTitle={setTitle}
                  setTotal={setTotal}
                  setProgress={setProgress}
                  setPosition={setPosition}
                  setCurrentId={setCurrentId}
                />
              </Route>
            </Switch>
          </div>
        </div>
        <div id="playerContainer">
          {downloading ? <p>Loading ...</p> : null}
          {position ? <p> In queue, position: {position}</p> : null}
          {progress ? (
            <p>
              <span>Processing server side: </span>
              {progress} / {total}
            </p>
          ) : null}
          <MediaSession
            title={title}
            artwork={[
              {
                src: "https://i.ytimg.com/vi/" + currentId + "/hqdefault.jpg",
                type: "image/jpeg",
              },
            ]}
          ></MediaSession>
          <audio id="audioplayer" ref={audioRef} controls={true}>
            <source
              type="audio/mpeg"
              src={"https://api-locktube.kazoo.agency/video/silence"}
            />
          </audio>
        </div>
      </ThemeProvider>
    </Router>
  );
};

export default App;
